/**
 * <nwf-trust-popovers>
 *
 * NWF-108: explanatory popovers on the trust badges.
 *
 * The design toggles them on click, not on hover - hover-only would be
 * unreachable on touch and keyboard. Each chip is a real <button> with
 * aria-expanded/aria-controls, so the disclosure is announced correctly.
 *
 * Only one popover is open at a time. Escape closes and returns focus to its
 * button; a click outside closes without moving focus.
 */
if (!customElements.get('nwf-trust-popovers')) {
    customElements.define(
        'nwf-trust-popovers',
        class NwfTrustPopovers extends HTMLElement {
            connectedCallback() {
                this.toggles = [...this.querySelectorAll('.nwf-trust-badges__toggle')];
                if (!this.toggles.length) return;

                this.onClick = this.handleClick.bind(this);
                this.onKeydown = this.handleKeydown.bind(this);
                this.onDocumentClick = this.handleDocumentClick.bind(this);

                this.addEventListener('click', this.onClick);
                this.addEventListener('keydown', this.onKeydown);
                document.addEventListener('click', this.onDocumentClick);
            }

            disconnectedCallback() {
                this.removeEventListener('click', this.onClick);
                this.removeEventListener('keydown', this.onKeydown);
                document.removeEventListener('click', this.onDocumentClick);
            }

            popoverFor(toggle) {
                return this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`);
            }

            close(toggle) {
                toggle.setAttribute('aria-expanded', 'false');
                const popover = this.popoverFor(toggle);
                if (popover) popover.hidden = true;
            }

            closeAll(except) {
                this.toggles.forEach((toggle) => {
                    if (toggle !== except) this.close(toggle);
                });
            }

            handleClick(event) {
                const toggle = event.target.closest('.nwf-trust-badges__toggle');
                if (!toggle || !this.contains(toggle)) return;

                const isOpen = toggle.getAttribute('aria-expanded') === 'true';
                this.closeAll(toggle);

                toggle.setAttribute('aria-expanded', String(!isOpen));
                const popover = this.popoverFor(toggle);
                if (popover) popover.hidden = isOpen;
            }

            handleKeydown(event) {
                if (event.key !== 'Escape') return;

                const open = this.toggles.find((t) => t.getAttribute('aria-expanded') === 'true');
                if (!open) return;

                this.close(open);
                open.focus();
            }

            handleDocumentClick(event) {
                if (this.contains(event.target)) return;
                this.closeAll();
            }
        },
    );
}
